export default __webpack_public_path__ + "static/media/categories_products.74973829.svg";